import { axios } from "..";
import { ICompany } from "../interfaces/models/ICompany";

export const getCompanies = async (): Promise<ICompany[]> => {
  try {
    const response = await axios.Get("./company");
    return response.data;
  } catch (error) {
    return [];
  }
};

export const getCompanyById = async (id: string): Promise<ICompany | null> => {
  try {
    const params = new URLSearchParams();
    params.append(
      "filter",
      JSON.stringify({ id: { value: id, comparisonType: "EQUAL" } })
    );
    const response = await axios.Get(`./company?${params.toString()}`);
    return Array.isArray(response.data) ? response.data[0] : response.data;
  } catch (error) {
    return null;
  }
};

export const createCompany = async (company: ICompany): Promise<ICompany> => {
  try {
    const response = await axios.Post("./company", company);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateCompany = async (company: ICompany): Promise<ICompany> => {
  try {
    const response = await axios.Put(`./company`, company);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteCompany = async (id: string): Promise<any> => {
  try {
    const response = await axios.Delete(`./company`, `${id}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

